import { CdnObjectDto, I18NText } from '@api/ChallengeClient';
import { getCdnImage } from '@components/utils/cdn-image';
import { I18n } from '@core/i18n';

export function imageUrl(image?: CdnObjectDto): string | undefined {
    return image?.bucketName && image?.objectKey
        ? getCdnImage(image.bucketName, image.objectKey)
        : undefined;
}

export function previewText(text?: I18NText): string | undefined {
    const values = Object.values(text ?? {}).filter((value) => value?.trim());
    return text?.[I18n.mainLanguageKey]?.trim() || values[0];
}

export function rowsOfWidgets<T>(
    widgets: T[],
    isTile: (widget: T) => boolean
): T[][] {
    return widgets.reduce<T[][]>((rows, widget) => {
        const last = rows[rows.length - 1];
        const pairsWithLast =
            isTile(widget) && last?.length === 1 && isTile(last[0]);
        return pairsWithLast
            ? [...rows.slice(0, -1), [last[0], widget]]
            : [...rows, [widget]];
    }, []);
}
